import * as React from 'react';
import Box from '@material-ui/core/Box';
import { MenuItem, Grid, TextField, Typography,Button,useTheme } from '@material-ui/core';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FormInput from "../../../../../FormInput";
import { pathOr } from "ramda";
import { MuiThemeProvider } from "@material-ui/core/styles";
import useStyles, { getMuiTheme } from "./styles";
import {  useSelector } from "react-redux";


import Collapse from '@mui/material/Collapse';

import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';



const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function CustomDashletFilter({ data,onChange,isSubmitFilter }) {

  const currentUserData = useSelector((state) => state.config.currentUserData);

  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const classes = useStyles();
  const theme = useTheme();
  const fields =pathOr([], ['data'], data);

  const dataisRightValue =pathOr('', ['isRightValue'], data);
  const isFieldLabel= pathOr([], ['isFieldLabel'], data);
  const isDisabled = pathOr(false, ['isDisabled'], data);

  const isRightValue= Object.values(fields).find((element) => {
    return element.name === dataisRightValue;
  });
  // console.log("fields",typeof(fields),fields)
  const showFields = (fields)=>{
    return Object.values(fields).map((field,fieldNum) => field.name && <Grid key={fieldNum} item xs={pathOr(12, ['grid','xs'], field)} sm={pathOr(12, ['grid','sm'], field)}><div key={fieldNum} className={data.isSubmit?classes.filterFieldBox:''}>
     {isFieldLabel? <Typography className={classes.axaLabel} key={fieldNum} >
        {field.label}
      </Typography>:null}

      <FormInput
         field={{...field,['label']:''}}
        //  field={{...field,['label']:'',['class']:classes.axaField}}
        //  initialValues={initialValues}
        value={field.value}
        //  dynamicEnumValue={initialValues[field.parentenum] || ""}
        module={field.module}
        small={true}
        reportsTo={field.reportsTo?pathOr('',['data','id'],currentUserData):null}
        onChange={(val) => onChange(field, val,data)}
        disabled={isDisabled}
         />
    </div>
    </Grid>
    )
  }
  return pathOr(true, ['isShow'], data)?
  <div className={classes.filterBox}>   <MuiThemeProvider theme={getMuiTheme(theme)}> <Grid
  container
  direction="row"
  // justifyContent="space-between"
  alignItems="center"
> 
{data.isHeader || data.isSubHeader?
<Grid item xs={7}>
         <Typography className={classes.axaLabel} >
        {data.label}
      </Typography>
  </Grid>:null}
<Grid item xs={4} style={{textAlign:'right'}}>
<span className={classes.axaLabel} >{pathOr(null, ['isRightText'], data)}</span>
  {dataisRightValue && pathOr(null, ['value'], isRightValue)}
  </Grid>
<Grid item xs={1} style={{textAlign:'right'}}>
  {data.isExpandIcon?  <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <FilterAltIcon color={!expanded?"primary":"disabled"} />
        </ExpandMore>:null}
  </Grid>
<Grid item xs={12}>
{data.isExpandIcon?
  <Collapse in={expanded} timeout="auto" unmountOnExit>
    <Grid
  container
  direction="row"
  // justifyContent="space-between"
  alignItems="center"
  spacing={1}
> 
    {showFields(fields)}

    {data.isSubmit?<Button variant="contained" size="small" color="primary"  onClick={()=>isSubmitFilter(data.id)} fullWidth={true}>{data.submitText}</Button>:null}
  </Grid></Collapse>:  <Grid
  container
  direction="row"
  // justifyContent="space-between"
  alignItems="center"
  spacing={1}
> {showFields(fields)}</Grid>}
  {!data.isExpandIcon && data.isSubmit?<Button variant="contained" size="small" color="primary"  onClick={()=>isSubmitFilter(data.id)} fullWidth={true}>{data.submitText}</Button>:null}
  
</Grid>
  </Grid>
</MuiThemeProvider>
  </div>:null
}
